import React, { useState } from "react";
import PropTypes from "prop-types";
import { displayLog } from "../common/common";
import { useDispatch } from "react-redux";
import { Box, FormControl, TextField, Typography } from "@mui/material";
import Modal from "@mui/material/Modal";
import Button from "@mui/material/Button";
import Div from "@jumbo/shared/Div";
import { setLoading } from "../../../redux/actions/DRM_user.action";


import { axios_tenant } from "../../../../axios";

const Createactivitycode = props => {
  const dispatch = useDispatch();
  const [pairCode, setPairCode] = useState("");
  const [activityCode, setActivityCode] = useState("");
  const [activityName, setActivityName] = useState("");

  if (!props.show) {
    return null;
  }

  const register = async () => {
    dispatch(setLoading(true));

    let req = {
      pair_code: pairCode,
      activity_code: activityCode,
      activity_name: activityName,
    }
    let response = await axios_tenant.post("/drm/createActivityCode", req).then((res) => res.data);
    if (response?.success) {
      displayLog("Activity Code Created", "success");
    } else {
      displayLog(response?.message, "error");
    }
    // 
    dispatch(setLoading(false));
    props.onCall();
    props.onClose();
    setPairCode("");
    setActivityCode("");
    setActivityName("");
  };

  const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 400,
    bgcolor: 'background.paper',
    borderRadius: 3,
    boxShadow: 24,
    p: 4,
  };

  // return (
  //   <div className="mod">
  //   <div className="mod-content container" /*style={HeaderStyle}*/>
  //     <div className="d-flex justify-content-between m-2 mt-3">
  //       <h4>Create Activity Code</h4>
  //       {/* <button onClick={props.onClose}>X</button> */}
  //       <i onClick={props.onClose} className="fa-solid fa-xmark"></i>
  //     </div>
  //     <form action="" className="container">
  //       <div>
  //         <label>Pair Code</label>
  //         <br />
  //         <input
  //           type="text"
  //           name="username"
  //           className="owner_input p-1 ps-2"
  //           value={pairCode}
  //           required
  //           onChange={(e) => {
  //             setPairCode(e.target.value);
  //           }}
  //         />
  //       </div>
  //       <div>
  //         <label>Activity Code</label>
  //         <br />
  //         <input
  //           type="text"
  //           name="username"
  //           className="owner_input p-1 ps-2"
  //           value={activityCode}
  //           required
  //           onChange={(e) => {
  //             setActivityCode(e.target.value);
  //           }}
  //         />
  //       </div>
  //       <div>
  //         <label>Activity Name</label>
  //         <br />
  //         <input
  //           type="text"
  //           name="username"
  //           className="owner_input p-1 ps-2"
  //           value={activityName}
  //           required
  //           onChange={(e) => {
  //             setActivityName(e.target.value);
  //           }}
  //         />
  //       </div>

  //       <div className="text-center m-3">
  //         <button
  //           id="sub_btn"
  //           type="submit"
  //           className="btn default-theme-btn"
  //           onClick={(e) => {
  //             e.preventDefault();
  //             register();
  //           }}
  //         >
  //           Submit
  //         </button>
  //       </div>
  //     </form>
  //   </div>
  //   </div>
  // );

  return (
    <Modal
      open={props.show}
      onClose={props.onClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Div sx={style}>

        <Typography id="modal-modal-title" variant="h4" component="h2">
          Create Activity Code
        </Typography>
        <br></br> {/* could b removed and just add margin below */}
        <Typography id="modal-modal-title" variant="h6" component="h6">
          <FormControl fullWidth>

            <TextField
              sx={{ mb: 1 }}
              id="pair_code"
              label="PAIR Code"
              value={pairCode}
              required
              onChange={(e) => {
                setPairCode(e.target.value);
              }}
            />
            <br></br>
            <TextField
              sx={{ mb: 1 }}
              id="activity_code"
              label="Activity Code"
              value={activityCode}
              onChange={(e) => {
                setActivityCode(e.target.value);
              }}
            />
            <br></br>
            <TextField
              sx={{ mb: 1 }}
              id="activity_name"
              label="Activity Name"
              value={activityName}
              required
              onChange={(e) => {
                setActivityName(e.target.value);
              }}
            />
            <br></br>

          </FormControl>

        </Typography>

        <Box textAlign="right" sx={{ mt: 2 }}>
          <Button type="submit"
            variant="contained"
            color="primary"
            disabled={!pairCode || !activityName}
            onClick={(e) => {
              e.preventDefault();
              register();
            }} >
            Submit
          </Button>{" "}
          <Button type="submit"
            variant="contained"
            color="primary"
            onClick={props.onClose} >
            Cancel
          </Button>
        </Box>
      </Div>
    </Modal>
  );
}


Createactivitycode.propTypes = {
  show: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onCall: PropTypes.func.isRequired,
};

export default Createactivitycode;